module.exports = __webpack_public_path__ + "img/image-02.43e4c6e0.jpg";